/**
 * ------------------------------------------------------------------------
 * Tools - Public
 * ------------------------------------------------------------------------
 */
const getSelector = (element, attribute) => {
  let selector = element.getAttribute(attribute)

  if (!selector || selector === '#') {
    let hrefAttr = element.getAttribute('href')

    if (!hrefAttr || (!hrefAttr.includes('#') && !hrefAttr.startsWith('.'))) {
      return null
    }

    if (hrefAttr.includes('#') && !hrefAttr.startsWith('#')) {
      hrefAttr = `#${hrefAttr.split('#')[1]}`
    }

    selector = hrefAttr && hrefAttr !== '#' ? hrefAttr.trim() : null
  }

  return selector
}

const getSelectorFromElement = (element, attribute) => {
  const selector = getSelector(element, attribute)

  if (selector) {
    return document.querySelector(selector) ? selector : null
  }

  return null
}

const onToggle = (element, nameClass = CLASS_NAME_SHOW$1) => {
  element.classList.toggle(`${nameClass}`)
}

const onShow = (element, nameClass = CLASS_NAME_SHOW$1) => {
  if (element.classList.contains(nameClass)) {
    return null
  }

  element.classList.add(`${nameClass}`)
}

const onHide = (element, nameClass = CLASS_NAME_SHOW$1) => {
  if (!element.classList.contains(nameClass)) {
    return null
  }

  element.classList.remove(`${nameClass}`)
}

const updatedAttributes = (element, attribute, value) => {
  if (element === null) return null

  if (!element.hasAttribute(attribute)) return null

  element.setAttribute(attribute, value)
}

const onAriaExpanded = (element) => {
  if (element.ariaExpanded === null) return null

  if (element.ariaExpanded === 'true') return (element.ariaExpanded = 'false')

  return (element.ariaExpanded = 'true')
}

const onStylesELement = (element, styles = '') => {
  if (element === null) return null

  element.setAttribute('style', styles)
}